import styled, { css } from 'styled-components';

import { xdlColorDisabled } from '@xingternal/tokens';
import { Headline } from '@xingternal/typography';

export const MarkLabel = styled(Headline)<{ $isDisabled: boolean }>`
  float: left;

  &:last-child {
    float: right;
  }

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      color: ${xdlColorDisabled};
    `}
`;
